// extracted by mini-css-extract-plugin
export var falconContainer = "_wf-2";
export var offerCenter = "_wf-0";
export var roktContainer = "_wf-1";